
import { defineComponent, ref, PropType, computed, toRaw } from 'vue'
import { ElMessage } from 'element-plus'
import { IarchivesType, Iarchives_l } from '@/store/page-file/types'

export default defineComponent({
  props: {
    archives: Object as PropType<IarchivesType>
  },
  setup(props, context) {
    let date = new Date()
    let max_year: number = date.getFullYear()
    let Year = ref<number>(max_year)
    type FooFnType = () => void
    // 上下年份选择
    let per_data: FooFnType = () => {
      Year.value--
      if (Year.value < 2017) {
        ElMessage({
          message: '没有更过年份.',
          type: 'warning'
        })
        Year.value = 2017
      }
    }
    let cur_data: FooFnType = () => {
      Year.value++
      if (Year.value > max_year) {
        ElMessage({
          message: '没有更过年份.',
          type: 'warning'
        })
        Year.value = max_year
      }
    }
    // 是否在当月有文章
    type FnType = (s: string, y: number) => { key: boolean; value: number }
    const readNum = computed<FnType>(() => (s, y) => {
      let b = y < 10 ? `0${y}` : y
      if (typeof props.archives === 'object') {
        return {
          key: Object.keys(props.archives).includes(`${s}-${b}`),
          value: props.archives[`${s}-${b}`]?.length
        }
      }
      return {
        key: false,
        value: 0
      }
    })
    // 筛选月份文章
    type filterArticlesFn = (s: string, y: number) => void
    let filter_articles: filterArticlesFn = (s, y) => {
      let b = y < 10 ? `0${y}` : y
      if (typeof props.archives === 'object') {
        if (Object.keys(props.archives).includes(`${s}-${b}`)) {
          let obj: IarchivesType = {}
          obj[`${s}-${b}`] = [...props.archives[`${s}-${b}`]]
          context.emit('onArticles', obj)
        }
      }
    }
    // 关闭
    let close = () => {
      context.emit('onArticles')
    }
    return {
      per_data,
      cur_data,
      Year,
      readNum,
      filter_articles,
      close
    }
  }
})
